export default __webpack_public_path__ + "static/logo-23190603ccd7e01836ff907d0a46dce5.svg";